<template>
  <section v-loading="loading" id="admin-work-sheet" class="case-creation">
    <div class="container-sm">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__body pb-0">
            <el-form :model="testConfig" class="vue-form">
              <el-row :gutter="20">
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Case Type <span class="star">*</span></label
                      >
                      <el-select
                        v-model="testConfig.case_type"
                        placeholder="Select Case Type"
                        :disabled="isEditConfig"
                      >
                        <el-option
                          v-for="caseType in CaseTypes"
                          :key="caseType"
                          :label="caseType.label"
                          :value="caseType.value"
                        >
                        </el-option>
                      </el-select>
                      <p class="err">
                        <FormError errorName="case_type"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Status
                      </label>
                      <el-select
                        :disabled="isEditConfig"
                        v-model="testConfig.status"
                        placeholder="Select Status"
                      >
                        <el-option
                          v-for="item in statusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <p class="err">
                        <FormError errorName="status"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        S.No
                        <span class="star">*</span>
                      </label>
                      <el-input
                        :disabled="isEditConfig"
                        placeholder="Enter S.No"
                        v-model="testConfig.id"
                        maxlength="10"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="id"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">Flag name </label>
                      <el-select
                        v-model="testConfig.path_flags"
                        multiple
                        :disabled="isEditConfig"
                      >
                        <el-option label="resp" value="resp"> </el-option>
                      </el-select>

                      <p class="err">
                        <FormError errorName="path_flags"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Display Name
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Phone Number"
                        v-model="testConfig.display_name"
                        maxlength="10"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="display_name"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Long Name
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Long Name"
                        v-model="testConfig.long_name"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="long_name"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Assay Id
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Assay Id"
                        v-model="testConfig.assay_id"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="assay_id"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >AMP Score
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Amp Score"
                        v-model="testConfig.amp_score"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="amp_score"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >CQ Config Value
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="CQ Config Value"
                        v-model="testConfig.cq_conf_threshold"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="cq_conf_threshold"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col
                  :xl="3"
                  :lg="4"
                  :md="8"
                  :sm="12"
                  :xs="12"
                  v-if="testConfig.assay_id == 'MS2'"
                >
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        CQ Upper Limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="CQ Upper Limit"
                        v-model="testConfig.cq_upper_limit"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="cq_upper_limit"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col
                  :xl="3"
                  :lg="4"
                  :md="8"
                  :sm="12"
                  :xs="12"
                  v-if="testConfig.assay_id == 'MS2'"
                >
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        CQ Lower Limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="CQ Lower Limit"
                        v-model="testConfig.cq_lower_limit"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="cq_lower_limit"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col
                  :xl="3"
                  :lg="4"
                  :md="8"
                  :sm="12"
                  :xs="12"
                  v-if="testConfig.case_type == 'COVID'"
                >
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        CT Threshold Upper Limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="CT Threshold Upper Limit"
                        v-model="testConfig.ct_threshold_upper_limit"
                      ></el-input>
                      <p class="err">
                        <FormError
                          errorName="ct_threshold_upper_limit"
                        ></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col
                  :xl="3"
                  :lg="4"
                  :md="8"
                  :sm="12"
                  :xs="12"
                  v-if="testConfig.case_type == 'COVID'"
                >
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        CT Threshold Lower Limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="CT Threshold Upper Limit"
                        v-model="testConfig.ct_threshold_lower_limit"
                      ></el-input>
                      <p class="err">
                        <FormError
                          errorName="ct_threshold_lower_limit"
                        ></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Lower CT Limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Lower CT Limit"
                        v-model="
                          testConfig.ct_threshold_upper_limit_of_low_abundance
                        "
                      ></el-input>
                      <p class="err">
                        <FormError
                          errorName="ct_threshold_upper_limit_of_low_abundance"
                        ></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text">
                        Medium CT Limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Medium CT Limit"
                        v-model="
                          testConfig.ct_threshold_upper_limit_of_medium_abundance
                        "
                      ></el-input>
                      <p class="err">
                        <FormError
                          errorName="ct_threshold_upper_limit_of_medium_abundance"
                        ></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >High CT limit
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="High CT limit"
                        v-model="
                          testConfig.ct_threshold_upper_limit_of_high_abundance
                        "
                      ></el-input>
                      <p class="err">
                        <FormError
                          errorName="ct_threshold_upper_limit_of_high_abundance"
                        ></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Group Target Names
                      </label>

                      <el-select
                        :disabled="isEditConfig"
                        v-model="testConfig.group_target_names"
                        multiple
                      >
                        <el-option label="RPP" value="RPP"> </el-option>
                      </el-select>
                      <p class="err">
                        <FormError errorName="group_target_names"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Group Display Name
                      </label>
                      <el-input
                        :disabled="isEditConfig"
                        placeholder="Group Display Name"
                        v-model="testConfig.group_display_name"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="group_display_name"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Group Long Name
                      </label>
                      <el-input
                        :disabled="isEditConfig"
                        placeholder="Group Long Name"
                        v-model="testConfig.group_long_name"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="group_long_name"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Group Assay Name
                      </label>
                      <el-input
                        :disabled="isEditConfig"
                        placeholder="Group Assay Name"
                        v-model="testConfig.group_assay_name"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="group_assay_name"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Has UTI
                      </label>
                      <el-select
                        :disabled="isEditConfig"
                        v-model="testConfig.uti"
                        placeholder="Select Status"
                      >
                        <el-option
                          v-for="item in statusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <p class="err">
                        <FormError errorName="uti"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Antibiotic Resistance
                      </label>
                      <el-select
                        :disabled="isEditConfig"
                        v-model="testConfig.antibiotic_resistance"
                        placeholder="Select"
                      >
                        <el-option
                          v-for="item in statusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>

                      <p class="err">
                        <FormError
                          errorName="antibiotic_resistance"
                        ></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"
                        >Devansh uti3
                      </label>
                      <el-input
                        :disabled="isEditConfig"
                        v-model="testConfig.devansh_uti3"
                      ></el-input>
                      <p class="err">
                        <FormError errorName="devansh_uti3"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <p class="err">
                    <FormError errorName="critical_error"></FormError>
                  </p>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="case-creation__actions">
          <ul class="list">
            <li>
              <el-button
                type="default"
                class="btn cancel-button"
                @click="cancelWorksheet"
                >Cancel</el-button
              >
            </li>
            <li>
              <el-button
                type="success"
                class="btn save-button"
                @click="submitWorkSheet"
                :loading="loading"
              >
                Save
              </el-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";

const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      testConfig: {},
      CaseTypes: [
        {
          label: "Covid",
          value: "COVID",
        },
        {
          label: "Covid and Flu",
          value: "COVID_FLU",
        },
        {
          label: "Respiratory",
          value: "RESPIRATORY_PATHOGEN_PANEL",
        },
        {
          label: "UTI",
          value: "UTI",
        },
      ],
      statusOptions: [
        { label: "True", value: true },
        {
          label: "False",
          value: false,
        },
      ],
    };
  },
  components: {
    FormError,
  },
  computed: {
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("labs", [
      "getCreateWorkSheetStaus",
      "getSingleWorkSheetDetails",
    ]),
    labId() {
      return this.$route.params.lab_id;
    },
    isEditConfig() {
      return this.$route.params.target_name_id ? true : false;
    },
  },
  async mounted() {
    this.$store.dispatch("errors/clear");
    await this.loadInitData();
  },
  methods: {
    loadInitData() {
      if (this.$route.params.target_name_id) {
        this.checkConfigData();
      } else {
        this.loading = false;
      }
    },
    async checkConfigData() {
      try {
        this.loading = true;
        let params = {
          lab_id: this.labId,
          test_report_target_name_id: this.$route.params.target_name_id,
        };
        await this.$store.dispatch("labs/fetchSingleTestConfig", params);
        this.testConfig = { ...this.getSingleWorkSheetDetails };
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    cancelWorksheet() {
      this.$router.push({ name: "WorkSheets" });
    },
    async submitWorkSheet() {
      try {
        await this.$store.dispatch("labs/createWorkSheet", {
          config: this.testConfig,
          lab_id: this.labId,
        });
        if (this.getCreateWorkSheetStaus) {
          successNotification(
            this.$route.params.lab_id
              ? "Test report target name updated successfully"
              : "Test report target name created successfully"
          );
          this.$router.push({ name: "WorkSheets" });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss">
#admin-work-sheet {
  .err {
    white-space: break-spaces;
  }
}
</style>
